import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import RequireAuth from '../RequireAuth';
import { RouteTableProvider } from './RouteTableProvider';
import { V3Context } from './V3Context';
import { LIGHT_ENABLED, useV3Theme } from './useV3Theme';
import V3Shell from './V3Shell';
import V3SignIn from './V3SignIn';
import ActionsPage from './pages/ActionsPage';
import DashboardPage from './pages/DashboardPage';
import DevicesPage from './pages/DevicesPage';
import FindingsPage from './pages/FindingsPage';
import PoliciesPage from './pages/PoliciesPage';
import './v3.css';

// Everything under /v3: its own sign-in, layout and colours (ves-web's look, scoped to .v3). The current site's navbar, theme and routes
// are not used here. V3 is admin only.
export default function V3App() {
  const [mode, toggleMode] = useV3Theme();
  return (
    <V3Context.Provider value={{ mode, toggleMode, lightEnabled: LIGHT_ENABLED }}>
      <div className="v3" data-v3-theme={mode} data-testid="v3-root">
        <Routes>
          <Route path="/v3/signin" element={<V3SignIn />} />
          <Route element={<RequireAuth roles={['admin']} signInPath="/v3/signin"><RouteTableProvider><V3Shell /></RouteTableProvider></RequireAuth>}>
            <Route path="/v3" element={<Navigate to="/v3/dashboard" replace />} />
            <Route path="/v3/dashboard" element={<DashboardPage />} />
            <Route path="/v3/policies" element={<PoliciesPage />} />
            <Route path="/v3/devices" element={<DevicesPage />} />
            <Route path="/v3/findings" element={<FindingsPage />} />
            <Route path="/v3/actions" element={<ActionsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/v3/dashboard" replace />} />
        </Routes>
      </div>
    </V3Context.Provider>
  );
}
